<div class="search-input-wrapper">
  <input [(ngModel)]="searchInput"
         (ngModelChange)="searchService.searchQuery$.next($event)"
         type="text"
         placeholder="Search"
         class="search-input">
  <button class="search-button" app-icon-button [iconSize]="searchInput === '' ? '20px' : '16px'" (click)=" searchService.searchQuery$.next(''); searchInput = '';">
    <app-icon
      [svgIcon]="searchInput === '' ? 'searchIcon' : 'cancel'"
      class="icon-animate"
    ></app-icon>
  </button>
</div>
